module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("auJzN"))).then(() => parcelRequire('XZobX'));